import React, { useState } from 'react';

export default function DialogTile({ children, bgClassName, onClick, selectedBg, ...other }) {
  const selected = selectedBg === bgClassName;

  return (
    <div data-tileclass={bgClassName} onClick={onClick} className="popup-dialog__tile" {...other}>
      <div className={`bg-sel-tile-bg ${bgClassName}`}>
        <div
          className="bg-sel-tile"
          tabIndex="-1"
          role="button"
          style={{ opacity: 1 }}
        >
          {selected &&
            (<div className="selected-border">
              <div className="selected-circle"></div>
              <div className="selected-check"></div>
            </div>)
          }
          <div className="bg-sel-tile-title">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
